export default [
  {
    path: '/listError',
    name: 'listErrors',
    component: () => import('@/views/menu/error/listErrors.vue'),
    meta: {
      pageTitle: 'لیست خطاها',
      action: 'show',
      resource: 'ErrorManager',
    },
  },
  {
    path: '/errorDetails/:id',
    name: 'errorDetails',
    component: () => import('@/views/menu/error/errorDetails.vue'),
    meta: {
      pageTitle: 'جزئیات یک خطا',
      action: 'show',
      resource: 'ErrorManager',
    },
  },
]
